module.exports = __webpack_public_path__ + "img/TOMMputer.a89d9ce1.svg";